import { FC, useMemo } from "react";
import { Box, Skeleton, Text } from "@chakra-ui/react";
import { useFlagsStatus, useVariant } from "@unleash/proxy-client-react";

import {
  isStringWithNumber,
  getMainPaymentMethod,
  formatPriceWithoutZeros,
} from "../../../../../../utils";
import {
  MainPagePaymentScheduleCommissionError,
} from "./MainPagePaymentScheduleCommissionError";
import { UnleashFlags } from "../../../../../../constants";
import { useGetCardsQuery } from "../../../../../../api/cards";

interface Props {
  paymentAmount: string | undefined;
}

export const MainPagePaymentScheduleCommission: FC<Props> = ({ paymentAmount }) => {
  const flagsStatus = useFlagsStatus();
  const flagsReady = flagsStatus.flagsReady;
  const flagsError = Boolean(flagsStatus.flagsError);

  const { data: cards, isPending: isCardsPending } = useGetCardsQuery();

  const mainPaymentMethod = useMemo(() => {
    return getMainPaymentMethod(cards);
  }, [cards]);

  const commissionVariant = useVariant(UnleashFlags.dfPaymentsCommission);
  const commissionValue = commissionVariant.payload?.value;
  const commissionAmount
        = mainPaymentMethod?.terminalType === "PAID"
        && isStringWithNumber(commissionValue)
        && isStringWithNumber(paymentAmount)
          ? Number(paymentAmount) * (Number(commissionValue) / 100)
          : 0;

  const totalAmount = Number(paymentAmount || 0) + commissionAmount;
  const totalAmountWithCurrency = formatPriceWithoutZeros(totalAmount);

  const isPaid = mainPaymentMethod?.terminalType === "PAID";
  const isCommissionValid = isStringWithNumber(commissionValue);

  if (isCardsPending || (isPaid && !flagsReady && !flagsError)) {
    return <Skeleton h="12px" mt="4px" />;
  }

  if (isPaid && (flagsError || (flagsReady && !isCommissionValid))) {
    return <MainPagePaymentScheduleCommissionError />;
  }

  if (isPaid && flagsReady && isCommissionValid) {
    return (
      <Text fontSize="12px" mb="24px">
        {`с учётом комиссии спишем ${totalAmountWithCurrency}`}
      </Text>
    );
  }

  return <Box h="16px" />;
};
